import { render } from "./dates-hris.vue?vue&type=template&id=b9441f74&lang=pug"
import script from "./dates-hris.vue?vue&type=script&lang=js"
export * from "./dates-hris.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__